import React, { useState, useEffect, useRef } from 'react'

const Search = () => {
  const urlParams = new window.URLSearchParams(window.location.search)
  const [value, setValue] = useState(urlParams.get('q') || '')
  const inputRef = useRef(null)

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && value.trim().length > 0) {
      window.location.href = `/search?q=${encodeURIComponent(value.trim())}`
    }
  }

  // Global keyboard shortcuts to focus the search input:
  //   ⌘/Ctrl+K — works from anywhere, even while typing (Slack/Linear convention)
  //   / — works only when no input/textarea/contenteditable is focused, so
  //       users can still type "/" in comments without focus stealing
  //       (Twitter/YouTube/GitHub convention).
  useEffect(() => {
    const isEditable = (el) => {
      if (!el) { return false }
      const tag = el.tagName
      return tag === 'INPUT' || tag === 'TEXTAREA' || el.isContentEditable
    }

    const onGlobalKeyDown = (e) => {
      const cmdK = (e.metaKey || e.ctrlKey) && e.key === 'k'
      const slash = e.key === '/' && !isEditable(e.target)
      if (cmdK || slash) {
        e.preventDefault()
        inputRef.current?.focus()
        inputRef.current?.select()
      }
    }
    document.addEventListener('keydown', onGlobalKeyDown)
    return () => document.removeEventListener('keydown', onGlobalKeyDown)
  }, [])

  return (
    <div className='flex-1'>
      <div className="mx-auto w-full max-w-xs lg:max-w-md">
        <label htmlFor="search" className="sr-only">Search</label>
        <div className="relative text-cccblue dark:text-white">
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fillRule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clipRule="evenodd" />
            </svg>
          </div>
          <input
            ref={inputRef}
            id="search"
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={handleKeyDown}
            className="block w-full rounded-md border border-2 border-opacity-30 border-cccblue bg-cccblue bg-opacity-5 py-2 pl-10 pr-3 text-gray-900 dark:text-gray-100 sm:text-sm"
            placeholder="Search members, credits, or projects... (/ or ⌘K)"
          />
        </div>
      </div>
    </div>
  )
}

export default Search

Search.propTypes = {}
